export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size * 0.67} viewBox="0 0 48 32" aria-hidden="true">
    <path d="M13 21 C12 14 14 8 18 7 C21 6.5 22 9 24 8.5 C26 8 27 6.5 30 7 C34 8 36 14 35 21 Z" fill="#a06a3c" />
    <path d="M18.5 9 C20 12 21 15 21 19" stroke="#7a4b26" strokeWidth="1" fill="none" />
    <path d="M13.2 17.2 C20 18.8 28 18.8 34.8 17.2 L35 20.6 C28 22.2 20 22.2 13 20.6 Z" fill="#3b2416" />
    <path d="M2 22 C8 28 40 28 46 22 C42 19.5 37 20 35 20.6 C28 22.4 20 22.4 13 20.6 C11 20 6 19.5 2 22 Z" fill="#8a5a32" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none text-[#e6d9bd]">
      <span className="brand-word block text-2xl">
        MUTONI<sup className="ml-0.5 text-[9px] align-super">®</sup>
      </span>
      <span className="brand-word block text-[11px] tracking-[0.22em] opacity-80">MUSEO DIGITAL</span>
    </span>
  </span>
);
